import { confirm } from '@/components/confirm-dialog';
import { toast } from 'sonner';
import { openSupportDrawer, SUPPORT_TYPES } from '../../../redux/slices/supportDrawerSlice';
import { setIsDarkTheme } from '../../../redux/slices/appSlice';
import { setIsSchedulingFormOpen } from '../../../redux/slices/schedulingFormSlice';
import logoutHandler from '../../controllers/logoutHandler';
import { openHelpChat } from '../../../redux/slices/helpChatSlice';
import { ACTION_TYPES } from '../../../constants/navigation/commandRegistry';
import { PAGE_TOUR, startTour, WELCOME_TOUR } from '../../../redux/slices/tourSlice';

export async function copyCurrentPageLink() {
  try {
    await navigator.clipboard.writeText(window.location.href);
    toast.success('Link copied', {
      description: 'The current page URL was copied to your clipboard.',
    });
  } catch {
    toast.error('Could not copy link');
  }
}

export function confirmLogout() {
  confirm({
    title: 'Logout',
    description: 'Are you sure you want to logout?',
    onConfirm: () => {
      logoutHandler();
    },
    confirmText: 'Logout',
    cancelText: 'Cancel',
    variant: 'destructive',
  });
}

export function executeCommandAction(item, { dispatch, isDarkTheme }) {
  switch (item.actionType) {
    case ACTION_TYPES.SCHEDULE_MEETING:
      dispatch(setIsSchedulingFormOpen(true));
      break;
    case ACTION_TYPES.TOGGLE_THEME: {
      const nextTheme = !isDarkTheme;
      localStorage.setItem('isDarkTheme', nextTheme);
      dispatch(setIsDarkTheme(nextTheme));
      document.body.className = nextTheme ? 'dark' : 'light';
      document.documentElement.className = nextTheme ? 'dark' : 'light';
      break;
    }
    case ACTION_TYPES.OPEN_SUPPORT:
      dispatch(openSupportDrawer(SUPPORT_TYPES.SUPPORT));
      break;
    case ACTION_TYPES.OPEN_FEEDBACK:
      dispatch(openSupportDrawer(SUPPORT_TYPES.FEEDBACK));
      break;
    case ACTION_TYPES.COPY_PAGE_LINK:
      copyCurrentPageLink();
      break;
    case ACTION_TYPES.OPEN_HELP_CHAT:
      dispatch(openHelpChat());
      break;
    case ACTION_TYPES.START_PAGE_TOUR:
      dispatch(startTour(PAGE_TOUR));
      break;
    case ACTION_TYPES.START_WELCOME_TOUR:
      dispatch(startTour(WELCOME_TOUR));
      break;
    case ACTION_TYPES.LOGOUT:
      confirmLogout();
      break;
    default:
      break;
  }
}
